// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__12X1O","text":"SelectPayment_text__3rxmD","title":"SelectPayment_title__3gSYv","btn":"SelectPayment_btn__2RKiZ"};